module.exports = __webpack_public_path__ + "img/about.1279371c.svg";